export class CalendarUtils {
    private static easterSundaysCache: { [year: number]: Date } = {};

    // https://gist.github.com/johndyer/0dffbdd98c2046f41180c051f378f343
    public static calculateEasterSunday(year: number): Date {
        if (year in CalendarUtils.easterSundaysCache) {
            return CalendarUtils.easterSundaysCache[year];
        }

        const C = Math.floor(year / 100);
        const N = year - 19 * Math.floor(year / 19);
        const K = Math.floor((C - 17) / 25);
        let I = C - Math.floor(C / 4) - Math.floor((C - K) / 3) + 19 * N + 15;
        I = I - 30 * Math.floor((I / 30));
        I = I - Math.floor(I / 28) * (1 - Math.floor(I / 28) * Math.floor(29 / (I + 1)) * Math.floor((21 - N) / 11));
        let J = year + Math.floor(year / 4) + I + 2 - C + Math.floor(C / 4);
        J = J - 7 * Math.floor(J / 7);
        const L = I - J;
        const M = 3 + Math.floor((L + 40) / 44);
        const D = L + 28 - 31 * Math.floor(M / 4);

        return CalendarUtils.easterSundaysCache[year] = new Date(year, M - 1, D);
    }

    public static isWeekend(date: Date): boolean {
        return date.getDay() % 6 === 0;
    }

    public static isLeapYear(year: number): boolean {
        return new Date(year, 1, 29).getDate() === 29;
    }
}
